import {SystemSettingsState} from './states/system-settings.state';

export const systemSettingsState = [
    SystemSettingsState
];
